import { useCartStore } from '../stores/cart';

let queueTail: Promise<void> = Promise.resolve();

export const enqueueCartMutation = <T>(operation: () => Promise<T>): Promise<T> => {
  const cartStore = useCartStore();
  cartStore.startCartMutation();
  const queuedOperation = queueTail.then(operation);
  queueTail = queuedOperation.then(
    () => undefined,
    () => undefined,
  );
  return queuedOperation.finally(() => cartStore.finishCartMutation());
};
